import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { useFeature } from "../lib/use-tariff";

/**
 * Eksport tugmasi — `export` feature'iga bog'liq (Max/Trial). Tarif yo'q bo'lsa
 * dimmed + "Max" badge (upsell), bosilganda eslatma chiqaradi.
 */
export function ExportButton({
  onExport,
  label,
}: {
  onExport: () => Promise<void>;
  label?: string;
}) {
  const { t } = useTranslation("ombor");
  const enabled = useFeature("export");
  const [busy, setBusy] = useState(false);
  const resolvedLabel = label ?? t("shared.export.label");

  if (!enabled) {
    return (
      <Button
        size="sm"
        variant="outline"
        className="opacity-60"
        title={t("shared.export.maxOnlyTitle")}
        onClick={() => toast.info(t("shared.export.maxOnlyToast"))}
      >
        <Download />
        <span className="hidden sm:inline">{resolvedLabel}</span>
        <Badge variant="outline" className="ml-1">Max</Badge>
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      variant="outline"
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          await onExport();
        } catch (e) {
          toast.error((e as { message?: string }).message || t("shared.export.error"));
        } finally {
          setBusy(false);
        }
      }}
    >
      <Download />
      <span className="hidden sm:inline">{busy ? t("shared.export.loading") : resolvedLabel}</span>
    </Button>
  );
}
